module.exports = __webpack_public_path__ + "static/22_tat11-255beb77ebb606972f0bc515e0192838.jpg";